import { render, staticRenderFns } from "./searchQuestionDialog.vue?vue&type=template&id=31b7ce1c&scoped=true"
import script from "./searchQuestionDialog.vue?vue&type=script&lang=js"
export * from "./searchQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./searchQuestionDialog.vue?vue&type=style&index=0&id=31b7ce1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7ce1c",
  null
  
)

export default component.exports